import { type CSSProperties, Fragment, useState } from 'react';
import { Drawer, Table } from 'antd';
import { type ColumnsType } from 'antd/lib/table/index.js';
import { type TableRowSelection } from 'antd/lib/table/interface.js';
import { type TAny, type TPlainObject } from '@flatbiz/utils';
import { columnFoldCache } from './cache.js';

type FoldOperateProps = {
  style?: CSSProperties;
  dataList: { dataIndex?: string; title: string }[];
  onChange: (keys: string[]) => void;
  open?: boolean;
  onClose?: () => void;
  cacheKey?: string;
  initSelectedRowKeys?: string[];
};

export const FoldOperate = (props: FoldOperateProps) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>(
    props.initSelectedRowKeys || []
  );
  const rowSelection = {
    type: 'checkbox',
    selectedRowKeys: selectedRowKeys,
    onChange: (selectedRowKeys: string[]) => {
      setSelectedRowKeys(selectedRowKeys);
      props.onChange(selectedRowKeys);
      if (props.cacheKey) {
        columnFoldCache.set(props.cacheKey, selectedRowKeys);
      }
    },
  } as TableRowSelection<TAny>;

  const columns: ColumnsType<TPlainObject> = [
    {
      title: '字段名称',
      dataIndex: 'title',
      render: (value, recrd) => {
        return recrd['_isFoldTitle'] || value;
      },
    },
    { title: '字段Key', dataIndex: 'dataIndex' },
  ];

  return (
    <Fragment>
      <Drawer
        title="选择字段"
        open={props.open}
        onClose={props.onClose}
        width={'35%'}
        styles={{
          body: {
            padding: 15,
          },
        }}
      >
        <Table
          bordered
          size="small"
          columns={columns}
          rowSelection={rowSelection}
          rowKey="dataIndex"
          pagination={false}
          scroll={{ x: 'max-content' }}
          dataSource={props.dataList}
        />
      </Drawer>
    </Fragment>
  );
};
